import { render, staticRenderFns } from "./FooterMod.vue?vue&type=template&id=39ea67a8&scoped=true&"
import script from "./FooterMod.vue?vue&type=script&lang=js&"
export * from "./FooterMod.vue?vue&type=script&lang=js&"
import style0 from "./FooterMod.vue?vue&type=style&index=0&id=39ea67a8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ea67a8",
  null
  
)

export default component.exports